import { useEffect, useState } from 'react'
import { GetSimilarProductsByMainArtNo } from '../../../Services/ProductService'
import { useAuth } from '../../../Providers/AuthProvider'
import { useConfig } from '../../../Providers/ConfigProvider'

const useGetSimilarProducts = (product) => {
    const [similarProducts, setSimilarProducts] = useState(null)
    const [isSimilarProductsLoading, setIsSimilarProductsLoading] = useState(false)
    const { authState } = useAuth()
    const { api } = useConfig()

    useEffect(() => {
        if (product)
            setIsSimilarProductsLoading(true)
        GetSimilarProductsByMainArtNo(api, product, authState.custId, authState.siteId, authState.whId)
            .then(res => {
                setSimilarProducts(res.data)

            })
            .catch(e => console.log(e))
            .finally(() => setIsSimilarProductsLoading(false))
    }, [product])

    return {
        similarProducts,
        isSimilarProductsLoading
    }
}

export default useGetSimilarProducts